import { call, put } from 'redux-saga/effects';
import types from '../redux/types';
import API from '../services/api';

export function* fetchCompanies() {
  try {
    const companies = yield call(API.getCompanies);
    if (companies && companies.companies && companies.companies.length === 0) {
      yield put({ type: types.SET_LOADING, payload: false });
      yield put({ type: types.REGISTER_STEP, payload: 2 });
      window.location.hash = '#/register';
    }
    if (companies && companies.companies && companies.companies.length > 0) {
      yield put({ type: types.LOAD_COMPANIES, payload: companies.companies });
      yield put({ type: types.SELECT_COMPANY, payload: companies.companies[0] });
    }
  } catch (error) {
    console.error("Couldn't fetch companies");
  }
}

export function* fetchCompany(cid) {
  try {
    const company = yield call(API.getCompany, cid);
    if (company) {
      yield put({ type: types.LOAD_COMPANIES, payload: [company] });
      yield put({ type: types.SELECT_COMPANY, payload: company });
    }
  } catch (error) {
    console.error("Couldn't fetch company");
  }
}
